import { Injectable } from '@angular/core';
import { environment } from '../../../env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class AstreinteService {
  host_Astreinte = `${environment.API_URI}/api/astreinte`;

  constructor(private http: HttpClient) { }

    private getAuthHeaders(): HttpHeaders {
    const purecloud_auth_data = localStorage.getItem('purecloud_auth_data');
    const token = purecloud_auth_data ? JSON.parse(purecloud_auth_data).accessToken : null;

    if (!token) throw new Error("Missing access token");

    return new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
  }

    getAllAstreinteByCodeDo(code_do: number) {
    const url = `${this.host_Astreinte}/select/${code_do}`;
    return this.http.get(url, { headers: this.getAuthHeaders() });
  }

  deleteAstreinte(code_Internes: number[]) {
    const url = `${this.host_Astreinte}/delete`;
     const options = {
      headers: this.getAuthHeaders(),
      body: { code_interne: code_Internes }
    };
    return this.http.delete(url, options);
  }

  // Récupérer la liste des astreintes par leur code DO
  getAstreintesList(code_do: number) {
    const url = `${this.host_Astreinte}/select/list/${code_do}`;
    return this.http.get(url, { headers: this.getAuthHeaders() });
  }

  // Ajouter une nouvelle astreinte
  addAstreinte(astreinte: any) {
    const url = `${this.host_Astreinte}/add`;
    return this.http.post(url, astreinte, { headers: this.getAuthHeaders() });
  }

  // récupérer la liste des pages d'astreintes
  getAstreinteListPages(code_do : number){
    const url = `${this.host_Astreinte}/select/page/${code_do}`;
    return this.http.get(url, { headers: this.getAuthHeaders() });
  }
   updateAstreinte(astreinte: any) {
    const url = `${this.host_Astreinte}/update`;
    return this.http.put(url, astreinte, { headers: this.getAuthHeaders() });
  }
    getAstreinteCriteresList(code_do : number){
    const url = `${this.host_Astreinte}/select/criteres/${code_do}`;
    return this.http.get(url, { headers: this.getAuthHeaders() });
  }
  deleteAstreinteCritere(code_Interne: number) {
    const url = `${this.host_Astreinte}/delete/critere`;
     const options = {
      headers: this.getAuthHeaders(),
      body: { code_interne: code_Interne }
    };
    return this.http.delete(url, options);
  }
  addAstreinteCritere(critere: any) {
    const url = `${this.host_Astreinte}/add/critere`;
    return this.http.post(url, critere, { headers: this.getAuthHeaders() });
  }

   updateAstreinteCritere(critere: any) {
    const url = `${this.host_Astreinte}/update/critere`;
    return this.http.put(url, critere, { headers: this.getAuthHeaders() });
  }

  getAstreinteTypeHoByCodeDo(code_do: number) {
    const url = `${this.host_Astreinte}/select/typeho/${code_do}`;
    return this.http.get(url, { headers: this.getAuthHeaders() });
  }
}
